module.exports = __webpack_public_path__ + "img/1564743638.2040766e.jpg";